var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiTickbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 50,
    viewBox: "0 0 60 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6065 0.865234H6.12025C3.21475 0.865234 0.859375 3.233 0.859375 6.15379V43.8373C0.859375 46.7581 3.21475 49.1258 6.12025 49.1258H43.6065C46.512 49.1258 48.8674 46.7581 48.8674 43.8373V6.15379C48.8674 3.233 46.512 0.865234 43.6065 0.865234Z",
    stroke: "#BCD171",
    strokeWidth: 1.73,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2999 11.533C12.7994 10.7387 10.129 12.1363 9.33886 14.6499C9.00881 15.6955 9.04881 16.8115 9.44888 17.827L16.46 35.6533C16.9601 36.9603 18.0603 37.9356 19.4105 38.2875C20.8308 38.6595 22.331 38.3076 23.5212 37.3323L59.6372 6.33496C59.6372 6.33496 59.6472 6.32491 59.6572 6.31485C59.9873 6.04339 60.1373 5.32953 59.8073 4.75644C59.4472 4.11296 58.6371 3.89177 57.997 4.25372C57.977 4.26378 57.947 4.28388 57.927 4.29394C57.917 4.29394 57.907 4.31405 57.887 4.31405L25.1515 23.9601C24.6314 24.2718 23.9613 24.1009 23.6512 23.5781C23.6512 23.5781 23.6512 23.5781 23.6512 23.568L17.9803 13.7048C17.3902 12.6792 16.44 11.905 15.3199 11.5431L15.2999 11.533Z",
    fill: "#F3B95B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiTickbox);
export default __webpack_public_path__ + "static/media/api_tickbox.9cdf03816aed26830db4ea7a967a5967.svg";
export { ForwardRef as ReactComponent };